<template lang="html">
  <div class="listing-preview" v-hotkey="keymap">
    <div class="dashboard-content-container margin-auto">
      <Navigation>
        <div class="flex-box exit-button-container">
          <SymbiumButton
            text="Exit Preview"
            :onClick="exit"
            :isSmall="true"
            :isPrimary="true"
          />
        </div>
      </Navigation>
      <div class="preview-container" @click="outsideClickCount = outsideClickCount + 1">
        <div>
          <div class="preview-form" @click="insideClickCount = insideClickCount + 1">
            <div class="product-form">
              <ImageSlide :imageURLs="previewData.imageURLs" />
              <div class="gap-3x" />
              <div class="big-body">{{previewData.name}}</div>
              <div class="big-body">By {{previewData.organizationName}}</div>
              <div class="gap-3x" />
              <div class="">{{previewData.sellingpoint.join(' · ')}}</div>
              <div class="gap-1x" />
              <div class="small-text">
                <span class="bg-green10 fg-green100 margin-right-2x bold padding-0-half-x">{{previewData.materialfinish[0].producttype}}</span>
                <span>{{previewData.bedroom}} Bed · {{previewData.bathroom}} Bath</span>
              </div>
              <div class="gap-3x" />
              <div class="line-break-gray" />
              <div class="gap-3x" />
              <div class="flex-box">
                <SymbiumButton
                  :text="contactButtonText"
                  :onClick="() => $emit('open-contact-modal')"
                  kclass="flex-grow-1 contact-button margin-right-2x"
                />
                <SymbiumButton
                  text="ADU Report"
                  :onClick="() => $emit('open-report-modal')"
                  kclass="flex-grow-1 contact-button"
                />
              </div>
              <PreviewSection title="Overview">
                <div class="gap-3x" />
                <div class="">{{previewData.description}}</div>
              </PreviewSection>

              <PreviewSection title="Cost">
                <QuestionGroup klass="product-detail-input" question="Estimated Cost" noBorder="true" noGap="true">
                  <div>{{previewData.materialfinish[0].cost}}</div>
                </QuestionGroup>
                <QuestionGroup klass="product-detail-input" question="Product Type" noBorder="true" noGap="true">
                  <div>{{previewData.materialfinish[0].producttype}}</div>
                </QuestionGroup>
                <QuestionGroup klass="product-detail-input" question="Includes" noBorder="true" noGap="true">
                  <div>{{formattedIncludes}}</div>
                </QuestionGroup>
              </PreviewSection>

              <PreviewSection title="Specifications">
                <QuestionGroup klass="product-detail-input" question="Building Area" noBorder="true" noGap="true">
                  <div>
                    <div>{{previewData.area}} sqft</div>
                  </div>
                </QuestionGroup>
                <QuestionGroup klass="product-detail-input" question="Building Height" noBorder="true" noGap="true">
                  <div>
                    <div>{{previewData.maxHeight}} ft</div>
                  </div>
                </QuestionGroup>
                <QuestionGroup klass="product-detail-input" question="Rooms" noBorder="true" noGap="true">
                  <div>{{formattedRooms}}</div>
                </QuestionGroup>
                <div class="gap-3x" />
              </PreviewSection>

              <PreviewSection title="Materials">
                <QuestionGroup
                  v-for="material in previewData.materialfinish[0].materialfinish"
                  :key="material[0]"
                  klass="product-detail-input"
                  :question="material[0]"
                  noBorder="true"
                  noGap="true"
                >
                  <div>{{material.slice(1, material.length).join(', ')}}</div>
                </QuestionGroup>
              </PreviewSection>

              <PreviewSection title="Financing">
                <QuestionGroup klass="product-detail-input" :question="previewData.financing.status" noBorder="true" noGap="true">
                  <div>{{previewData.financing.note}}</div>
                </QuestionGroup>
              </PreviewSection>


              <PreviewSection title="Customization">
                <QuestionGroup klass="product-detail-input" :question="previewData.customization.status" noBorder="true" noGap="true">
                  <div>{{previewData.customization.note}}</div>
                </QuestionGroup>
              </PreviewSection>


              <PreviewSection title="Contact Vendor">
                <div class="">Reach out to {{previewData.organizationName}} with a quick email letting them know you’re interested in this design.</div>
                <div class="gap-3x" />
                <SymbiumButton
                  :text="contactButtonText"
                  :onClick="() => $emit('open-contact-modal')"
                  kclass="flex-grow-1 contact-button margin-right-2x"
                  :isSmall="true"
                />
              </PreviewSection>
              <PreviewSection title="ADU Report">
                <div>Your free ADU Report includes information about your property, key regulations, and the steps to getting your ADU designed, approved, and built.</div>
                <div class="gap-3x" />
                <SymbiumButton
                  text="ADU Report"
                  :onClick="() => $emit('open-report-modal')"
                  kclass="flex-grow-1 contact-button"
                  :isSmall="true"
                />
              </PreviewSection>
            </div>

            <div class="gap-3x" />

            <div class="product-form compact-preview">
              <div class="gap-3x" />
              <div class="flex-box">
                <div class="info-left adu-foot-print">
                  <ImageSlide klass="compact" :imageURLs="previewData.imageURLs" />
                </div>
                <div class="info-right adu-foot-print flex-box vertically-centered ">
                  <img :src="previewData.aduFootPrint" />
                </div>
              </div>
              <div class="gap-3x" />
              <div class="bold">{{previewData.name}} by {{previewData.organizationName}}</div>
              <div class="gap-1x" />
              <div class="">{{previewData.sellingpoint.join(' · ')}}</div>
              <div class="gap-1x" />
              <div class="small-text">
                <span class="bg-green10 fg-green100 margin-right-2x bold padding-0-half-x">{{previewData.materialfinish[0].producttype}}</span>
                <span>{{previewData.bedroom}} Bed · {{previewData.bathroom}} Bath</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageSlide from 'src/components/common/utility/ImageSlide.vue'
import QuestionGroup from "src/components/common/QuestionGroup.vue";
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

import Navigation from "./components/Navigation.vue";
import PreviewSection from './components/PreviewSection.vue'

export default {
  components: { ImageSlide, QuestionGroup, PreviewSection, Navigation, SymbiumButton },
  props: ['previewData'],
  computed: {
    contactButtonText() {
      return `Contact ${this.previewData.organizationName}`;
    },
    formattedRooms() {
      var allRooms = [`Bedroom ${this.previewData.bedroom}`, `Bathroom ${this.previewData.bathroom}`].concat(this.previewData.rooms)
      return allRooms.join(', ')
    },
    formattedIncludes() {
      if(!this.previewData.materialfinish[0].includes) return ''
      return this.previewData.materialfinish[0].includes.join(', ')
    },
  },
  watch: {
    outsideClickCount() {
      setTimeout(() => {
        if(this.outsideClickCount > this.insideClickCount) {
          this.exit()
        }
      }, 50);
    }
  },
  methods: {
    exit() {
      this.$emit('exit-preview')
    }
  },
  data() {
    return {
      insideClickCount: 0,
      outsideClickCount: 0,
      keymap: {
        'esc': this.exit,
      }
    }
  },
  mounted() {
    window.scroll(0,0)
  }
}
</script>

<style lang="scss" scoped>
.listing-preview {
  .exit-button-container {
    width: 100%;
    justify-content: flex-end;
  }
}

.preview-form {
  width: 504px;
  margin: auto;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 504px;
  }
}

.preview-container {
  background: rgba(0, 0, 0, 0.6);
  padding: 72px;

  .product-form {
    padding: 24px;
  }

  .product-detail-input {
    .text-3x {
      line-height: 32px;
      margin-left: 0;
    }
  }

  .profile-preview {
    height: 192px;
  }

  .adu-foot-print {
    img {
      width: 144px;
      height: 192px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 24px 0px;

    .product-form {
      width: 100%;
      max-width: 504px;
    }

    .compact-preview {
      .info-left {
        margin-left: 0;
      }
    }

    .adu-foot-print {
      min-width: 76px;
      height: 176px;

      img {
        width: 28px;
        height: auto;
        margin: auto;
      }
    }
  }
}
</style>
